import { render, staticRenderFns } from "./DisclosureSexual.vue?vue&type=template&id=0a1eb376&scoped=true&lang=pug&"
import script from "./DisclosureSexual.vue?vue&type=script&lang=ts&"
export * from "./DisclosureSexual.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureSexual.vue?vue&type=style&index=0&id=0a1eb376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1eb376",
  null
  
)

export default component.exports